import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import ParameterFieldBase, { IParameterFieldBaseOptions } from './ParameterFieldBase';
import EditComponent, { IUriFieldOptions } from '../tsx/UriField';

import { validators } from './validators';

export default class UriField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [
        validators.string.shouldBe
        //validators.string.notEmpty
    ];

    public static EditComponent = EditComponent;

    constructor(
        glob: IGlob,
        title: string,
        validators?: any,
        defaultVal: string = '', //http:\/\/example.com',
        options?: IUriFieldOptions
    ) {
        super(glob, title, UriField.defaultValidators, validators, defaultVal, options);
    }
}
